<template>
  <span>
    <span :title="$t('serial') + ': ' + device.serial">{{
      device.description
    }}</span>
    <!-- Master Info -->
    <div v-if="device.master">
      <small>
        <span class="grey--text text--darken-1">
          {{ $t('decoderControlledBy') }}:
        </span>
        <router-link
          :title="$t('goToDecoderDetailPage')"
          :to="{
            name: 'decoder',
            params: {
              ctype: device.master.ctype,
              decoderId: device.master.id,
            },
          }"
        >{{ device.master.description }}</router-link>
      </small>
    </div>
  </span>
</template>

<script>
export default {
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Device/DeviceDescription.vue